export function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export function diffedJson(obj, old) {
	console.log('diffing', obj, old)
	const diffs = {};
	Object.keys(obj).forEach(key => {
		if (JSON.stringify(obj[key]) !== JSON.stringify(old[key]))
			diffs[key] = obj[key];
	});
	return diffs;
}

export function formatNumber(num, fixed) {
	if (!num) return "";
	if (typeof num === 'string')
		num = Number(num.replace(',', '.'))

	num = fixed ? num.toFixed(fixed) : num;
	return num
		.toString()
		.replace(".", ",")
		.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
}